import React from 'react';
import LocationPin from '../../../../assets/icons/locationPin';

import styles from './VenueLocation.module.scss';

interface MarkerProps {
    address: string | null;
    state: string | null;
    name: string | null;
    onClick: () => void;
    lat: number;
    lng: number;
}

const Marker = ({ address, name, state, onClick }: MarkerProps) => {
    /*'C-' is used in database records for differentiating CI states from others. Therefore, correcting state codes for UI.
    for example: Puerto Rico is PR for United States and C-PR for Caribbean Islands.*/
    let stateAbbr = state ? `, ${state.replace('C-', '')}` : '';
    return (
        <div className={styles.marker} onClick={onClick}>
            {address && <div className={styles.address}>{address}</div>}
            {address && (
                <div className={styles.tooltip}>
                    <p className={styles.tooltipName}>{name}</p>
                    <p className={styles.tooltipAddress}>{`${address}${stateAbbr}`}</p>
                </div>
            )}
            <LocationPin />
        </div>
    );
};

export default Marker;
